import * as React from "react";
import { Input } from "@neworbit/simpleui-input";
import { Moment } from "moment";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

interface Props {
    submit: (dueDate: Moment, notes: string, task: TaskModel) => Promise<void>;
    task: TaskModel;
}

interface State {
    dueDate: Moment;
    notes: string;
}

export class ChaseImmunisationBloodTestResultForm extends React.Component<Props, State> {

    public state: State = { dueDate: null, notes: "" };

    public render = () => {
        return (
            <>
                <Input.Date label="Due date" onChange={this.onDueDateChanged} />
                <Input.Text label="Notes" onChange={this.onNotesChanged} />
            </>
        );
    };

    public submit = () => this.props.submit(this.state.dueDate, this.state.notes, this.props.task);

    private onDueDateChanged = (dueDate: Moment) => this.setState({ dueDate });

    private onNotesChanged = (notes: string) => this.setState({ notes });
}
